var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard17(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#300B5C;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#300B5C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.1,95.6c-2.4-2.1-5.9-2.5-8.7-1.1l-43.9,21.4l-41.1-47.5c-1.5-1.7-3.7-2.7-6.1-2.8c-2.3,0-4.5,1-6,2.8 l-41,47.5L48.1,94.5c-4-1.8-8.8-0.1-10.6,4c-0.8,1.7-0.9,3.7-0.4,5.6l30.5,100.2c1,3.4,4.1,5.7,7.7,5.7h128.2c3.5,0,6.6-2.3,7.7-5.7 L241.5,104C242.5,101,241.5,97.7,239.1,95.6z M197.5,193.9H81.2L57.7,117l32.9,15.8c3.3,1.6,7.2,0.8,9.5-2l39.1-45l39.1,45.1 c2.4,2.7,6.3,3.5,9.6,1.8l32.9-16L197.5,193.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard17);
export default __webpack_public_path__ + "static/media/card1_7.985832b785336d262af94084359db835.svg";
export { ForwardRef as ReactComponent };